import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { WorkOrderStatusEnum } from 'gql/graphql';
import { getWorkOrderStatusLabel } from 'pages/Project/UerProject/WorkOrder/workOrderConstants';
import type { DefaultItemSelect } from 'uikit';
import { Button, cnMixSpace } from 'uikit';
import { newDate } from 'utils';

import * as R from 'ramda';
import type React from 'react';
import { useCallback, useMemo, useState } from 'react';

import { bimWorkOrderVersionGql } from '../workOrderVersionQueries';

import { BimWorkOrderVersionRequisitesRead } from './BimWorkOrderVersionRequisitesRead';

interface IWorkOrderVersionRequisitesProps {
    workOrderVersionId: number;
    activeItemVersion?: DefaultItemSelect;
    withButton?: boolean;
}

export const parseWorkOrder = R.evolve({
    signingDate: newDate,
    startDate: newDate,
    finishDate: newDate,
    workOrderChangeSigningDate: newDate,
    status: (id: WorkOrderStatusEnum) => ({ id, label: getWorkOrderStatusLabel(id) }),
});

export const BimWorkOrderVersionRequisites: React.FC<IWorkOrderVersionRequisitesProps> = (props) => {
    const { workOrderVersionId, withButton = true } = props;
    const [isOpen, setIsOpen] = useState(false);

    const variables = useMemo(() => ({ workOrderVersionId }), [workOrderVersionId]);

    const [workOrderResponse, workOrderState] = useRequest({
        requestId: 'bimWorkOrderVersion',
        query: bimWorkOrderVersionGql,
        variables,
        withEffect: isOpen,
    });

    const data = workOrderResponse?.bimWorkOrderVersion?.data;

    const defaultValues = useMemo(() => data && parseWorkOrder(data), [data]);

    const handleOnButtonClick = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleOnCloseModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    return (
        <>
            {withButton && (
                <Button
                    className={cnMixSpace({ mR: 'xs' })}
                    label="Просмотреть данные"
                    view="secondary"
                    size="s"
                    onClick={handleOnButtonClick}
                    loading={workOrderState === RequestStatus.FETCHING}
                />
            )}
            {isOpen && workOrderState === RequestStatus.SUCCESS && (
                <BimWorkOrderVersionRequisitesRead defaultValues={defaultValues} onCancel={handleOnCloseModal} />
            )}
        </>
    );
};

BimWorkOrderVersionRequisites.displayName = 'BimWorkOrderVersionRequisites';
